import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { getUserDetails } from './session-service';

export async function getAllChemicalChecklist() {
    try {
        const response = await apiGet('core', `chemical-checklist`);
        return response;
    } catch (e) { }
}

export async function getChemicalChecklist(id?: string) {
    try {
        const response = await apiGet('core', `chemical-checklist/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}

export async function addChemicalChecklist(newDetails: any) {
    try {
        const response = await apiPost('core', `chemical-checklist`, newDetails);
        return response;
    } catch (e) { }
}

export async function updateChemicalChecklist(newDetails: any, id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiPut('core', `chemical-checklist/${id}`, newDetails);

        return response;
    } catch (e) { }
}

export async function removeChemicalChecklist(id: any) {
    try {

        return await apiDelete('core', `chemical-checklist/${id}`);
    } catch (e) { }
}